/**
 * F4-QuickScope — bathroom branch. Maps the three product tiers into customer
 * language (Refresh / Full / Gut) without ever naming crew-days or codes.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Tier {
  code: string;
  label: string;
  sublabel: string;
}

const TIERS: Tier[] = [
  {
    code: 'BATH_REFRESH',
    label: 'Freshen it up',
    sublabel: 'New surround, vanity, paint and fixtures. Everything stays where it is.',
  },
  {
    code: 'BATH_FULL',
    label: 'Rebuild it, same layout',
    sublabel: 'New floor, a built-in niche, a lighting change, a fabricated countertop. Same footprint.',
  },
  {
    code: 'BATH_GUT',
    label: 'Change the layout',
    sublabel: 'Tub becomes a walk-in shower, tile to the ceiling, the works.',
  },
];

export function QuickScope(): JSX.Element {
  const navigate = useNavigate();
  const [picked, setPicked] = useState<string | undefined>();

  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <h1>Which sounds closest?</h1>
        <p className="stage-card__lede">
          A rough starting point &mdash; you&rsquo;ll fine-tune every part of it later. This just
          shapes the estimate we come back with.
        </p>
        <div className="options" role="radiogroup" aria-label="Which sounds closest?">
          {TIERS.map((t) => (
            <button
              key={t.code}
              type="button"
              className="pb-option"
              role="radio"
              aria-checked={picked === t.code}
              onClick={() => setPicked(t.code)}
            >
              <span style={{ flexGrow: 1 }}>
                <span className="pb-option__label">{t.label}</span>
                <span className="pb-option__sub">{t.sublabel}</span>
              </span>
            </button>
          ))}
        </div>
        <div className="q-actions">
          <button
            type="button"
            className="pb-btn pb-btn--next pb-btn--lg"
            disabled={!picked}
            onClick={() => navigate('/capture', { state: { serviceLine: 'BATHROOM', productCode: picked } })}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
